var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6464 5.76754C11.8417 5.57228 12.1583 5.57228 12.3536 5.76754L15.3536 8.76754C15.5488 8.9628 15.5488 9.27939 15.3536 9.47465C15.1583 9.66991 14.8417 9.66991 14.6464 9.47465L12.5 7.3282V14.9393C12.5 15.2154 12.2761 15.4393 12 15.4393C11.7239 15.4393 11.5 15.2154 11.5 14.9393V7.3282L9.35355 9.47465C9.15829 9.66991 8.84171 9.66991 8.64645 9.47465C8.45118 9.27939 8.45118 8.9628 8.64645 8.76754L11.6464 5.76754ZM6 13.4393C6.27614 13.4393 6.5 13.6631 6.5 13.9393V17.7575C6.5 17.7695 6.50479 17.7811 6.51331 17.7896C6.52184 17.7981 6.5334 17.8029 6.54545 17.8029H17.4545C17.4666 17.8029 17.4782 17.7981 17.4867 17.7896C17.4952 17.7811 17.5 17.7695 17.5 17.7575V13.9393C17.5 13.6631 17.7239 13.4393 18 13.4393C18.2761 13.4393 18.5 13.6631 18.5 13.9393V17.7575C18.5 18.0347 18.3899 18.3006 18.1938 18.4967C17.9977 18.6928 17.7318 18.8029 17.4545 18.8029H6.54545C6.26818 18.8029 6.00227 18.6928 5.80621 18.4967C5.61015 18.3006 5.5 18.0347 5.5 17.7575V13.9393C5.5 13.6631 5.72386 13.4393 6 13.4393Z",
    fill: "#197B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSmall);
export default __webpack_public_path__ + "static/media/upload-small.3e35cbf4e049d4629f19977283c8dc12.svg";
export { ForwardRef as ReactComponent };